import './person/person';
import './bankNumbers/bankNumbers';
import './accountswitchDates/accountswitchDates';
import './branchIds/branchIds';
import './advancedSettings/advancedSettings';
import './rbAustria/rbAustria';
import './atruviaUserDataModal/atruviaUserDataModal';
import './dispatchAddress/dispatchAddress';
